import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config';
import { getToken } from '../context/AuthContext';

const PLANS = [
  {
    id: 'monthly',
    label: 'Monthly',
    priceLabel: '$5',
    period: '/month',
    blurb: 'Flexible — cancel anytime',
  },
  {
    id: 'yearly',
    label: 'Yearly',
    priceLabel: '$50',
    period: '/year',
    blurb: 'Best value — 2 months free',
  },
];

export default function SubscribePage() {
  const { user, isSubscribed, authLoading } = useAuth();
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState('monthly');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (authLoading) return null;

  if (isSubscribed) {
    navigate('/');
    return null;
  }

  const handleCheckout = async (planId = selectedPlan) => {
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${config.apiBaseURL}/api/stripe/create-checkout-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ plan: planId }),
      });
      const data = await res.json();
      if (!res.ok) {
        if (data.error === 'already_subscribed' && data.portalUrl) {
          window.location.href = data.portalUrl;
          return;
        }
        setError(data.error || 'Could not start checkout');
        return;
      }
      window.location.href = data.url;
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card subscribe-card">
        <h2>Unlock Premium Features</h2>
        <p className="auth-hint">Subscribe to access AI Analysis, Options data, and Watchlists.</p>

        <ul className="feature-list">
          <li>AI-powered stock analysis</li>
          <li>Options &amp; Bollinger Band signals</li>
          <li>Personal watchlist</li>
        </ul>

        <div
          className="plan-options"
          style={{ display: 'grid', gap: 12, margin: '20px 0' }}
          role="radiogroup"
          aria-label="Subscription plan"
        >
          {PLANS.map((plan) => {
            const selected = selectedPlan === plan.id;
            return (
              <button
                key={plan.id}
                type="button"
                role="radio"
                aria-checked={selected}
                onClick={() => setSelectedPlan(plan.id)}
                style={{
                  textAlign: 'left',
                  cursor: 'pointer',
                  border: selected ? '2px solid var(--primary-color, #0B6E4F)' : '1px solid #ccc',
                  borderRadius: 10,
                  padding: '14px 16px',
                  background: selected ? 'rgba(11,110,79,0.06)' : '#fff',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <strong>{plan.label}</strong>
                  <span style={{ fontSize: 22, fontWeight: 700, color: 'var(--primary-color, #0B6E4F)' }}>
                    {plan.priceLabel}
                    <span style={{ fontSize: 14, fontWeight: 500 }}>{plan.period}</span>
                  </span>
                </div>
                <div className="auth-hint" style={{ marginTop: 4 }}>{plan.blurb}</div>
              </button>
            );
          })}
        </div>

        {error && <div className="auth-error">{error}</div>}

        {user ? (
          <button className="btn-primary" onClick={() => handleCheckout(selectedPlan)} disabled={loading}>
            {loading ? 'Redirecting…' : `Subscribe ${selectedPlan === 'yearly' ? 'yearly' : 'monthly'}`}
          </button>
        ) : (
          <div style={{ marginTop: 16 }}>
            <a href="/signup" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}>
              Create a free account to subscribe
            </a>
            <p className="auth-switch" style={{ marginTop: 8 }}>
              Already have an account? <a href="/login">Sign in</a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
